/* cookie权限弹窗 */
var cookiePopup = {
  isShowMore: false, // 展开收起更多说明

  // 显示弹窗
  showCookiePopup: function () {
    var $popup = $('.cookie-popup');
    if ($popup.length == 0) {
      return;
    }
    if (window.cateData.device == 'wap' || $popup.hasClass('dialog-box')) {
      $popup.css('display', 'flex');
      $popup.find('.dialog-mask').removeClass('dialog-mask-ani-fade-out');
      $popup.find('.dialog').removeClass('dialog-ani-to-top');
      $popup.find('.dialog-mask').addClass('dialog-mask-ani-fade-in');
      $popup.find('.dialog').addClass('dialog-ani-from-top');
      //禁止后方滚动
      setScroll.unScroll();
    } else {
      $popup.removeClass('cookie-popup-hide');
    }
  },
  // 关闭弹窗， 点击关闭跟点击确认弹窗逻辑相同
  confirm: function () {
    setCookie('ifCookie', '是', 180);
    this.closePopUp();
  },
  // 拒绝授权cookie
  refuse: function () {
    // if (isLogin()) {
    //   setCookie('ifCookie', '否', 5);
    // } else {
    //   // $.cookie('ifCookie', '否');
    //   document.cookie = "ifCookie=" + encodeURIComponent('否') + ';domain=.dellemc-solution.com;path=/';
    // }
    // 杨健说 客户反馈提示太频繁了，不管是否登录都存180天
    setCookie('ifCookie', '否', 180);
    this.closePopUp();
  },
  // 关闭弹窗
  closePopUp: function () {
    var $popup = $('.cookie-popup');
    if (window.cateData.device == 'wap' || $popup.hasClass('dialog-box')) {
      $popup.find('.dialog-mask').removeClass('dialog-mask-ani-fade-in');
      $popup.find('.dialog').removeClass('dialog-ani-from-top');
      $popup.find('.dialog-mask').addClass('dialog-mask-ani-fade-out');
      $popup.find('.dialog').addClass('dialog-ani-to-top');
      //取消禁止后方滚动
      setScroll.removeUnScroll();
      setTimeout(function () {
        $popup.css('display', 'none');
      }, 230);
    } else {
      $popup.addClass('cookie-popup-hide');
    }
  },
  // 展开收起说明
  toggleDesc: function () {
    this.isShowMore = !this.isShowMore;
    if(this.isShowMore){
      if (window.cateData.device == 'wap') {
        $('#moreInfo').css('height', '3.3rem');
      } else {
        $('#moreInfo').css('height', '84px');
      }
    }else{
      $('#moreInfo').css('height', '0');
    }
    $('.desc-toggle > .icon-xiangxia2').toggle();
    $('.desc-toggle > .icon-xiangshang2').toggle();
  },
  // 初始化弹窗
  init: function () {
    var isShow = true;
    var cookieAuth = getCookie('ifCookie');
    // 未登录用户已点击拒绝，关闭浏览器后再次打开继续弹窗
    // if (!isLogin() && cookieAuth == '否') {
    //   isShow = false;
    // }

    // 用户已点击确认，cookie有效期五天 || 登录用户点击拒绝，cookie有效期也是五天
    if (cookieAuth || window.location.host.indexOf('local.') > -1) {
      isShow = false;
    }

    if (isShow) {
      this.showCookiePopup();
    }
  }
};

cookiePopup.init();
